exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section[data-v-75fe4436]:first-of-type{margin-bottom:55px}.text-component[data-v-75fe4436]{margin-bottom:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75fe4436","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/pages/faq/style.scss
// module id = 1004
// module chunks = 0